<template>
    <nav class="navbar navbar-dark fixed-top bg-dark flex-md-nowrap p-0 shadow">
        <button class="navbar-toggler d-xl-none" type="button" data-toggle="collapse" data-target="#sidebar" aria-controls="sidebar" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>
        <router-link :to="{ name:'accueil' }" class="navbar-brand col-sm-3 col-md-2 mr-0">Macinstore 
            <!-- <div class="float-right" onclick="$('#sidebar').toggleClass('d-none');return false;"><span class="navbar-toggler-icon"></span></div> -->
        </router-link>
        <input v-model="searchText" class="form-control form-control-dark w-100" type="text" placeholder="Rechercher" aria-label="Rechercher" v-on:keyup.enter="search">
        <!-- <ul class="navbar-nav px-3">
            <li class="nav-item text-nowrap">
                <router-link :to="{ name: 'signout' }">Deconnection</router-link>
            </li>
        </ul> -->
    </nav>
</template>

<script>
export default {
    data() {
        return {
            searchText:''
        }
    },
    methods: {
        search() {
            if(this.searchText.length > 0) {
                this.$router.push({name: 'search',params: { search: this.searchText }}).catch(() => {})
                this.searchText = ''
            } else {
                this.$router.push({name: 'pecManager'}).catch(() => {})
            }
        }
    }
}
</script>

<style>

</style>
